// 🔹 WhatsappButton.js
const WhatsappButton = () => {
    return (
      <div style={{ position: "fixed", bottom: "22px", left: "25px" }}>
        <a href="/inquiry">
          <img height={50} src="/customer-support.png" alt="WhatsApp Chat" />
        </a>
      </div>
    );
  };
  
  export default WhatsappButton;